import mixins from "synergycms_core/src/less/mixins";

export default {
    defaultStyle:{
        position:'fixed',
        left:'20px',
        bottom:'20px',
        maxWidth:'250px',
        ...mixins.boxShadow('0 2px 4px 0 rgba(0, 0, 0, 0.2)'),
        zIndex:200,
        fontFamily:data => data.fontFamily1
    },
    webAdvantagesContainer :{},
    webAdvantagesButton:{
        position:'relative',
        textAlign: 'left',
        padding:'10px',
        backgroundColor:data => data.mainColor,
        width:'250px',
        color:'#fff',
        ...mixins.borderRadius('2px',0,0,'2px'),
    },
    webAdvantagesHeaderText:{
        color:'#fff',
        fontSize:'15px'
    },
    buttonIcon:{
        marginRight:'5px',
        fontSize:'15px'
    },
    buttonArrow:{
        position:'absolute',
        right:'10px',
        top:'50%',
        marginTop:'-5px',
        fontSize:'10px'
    },
    webAdvantagesBody:{
        backgroundColor:'#fff',
        padding:'10px 15px',
        overflow:'auto',
        maxHeight:'200px'
    },
    webAdvantagesPrice:{
        display:'table',
        width:'100%',
        marginBottom:'10px'
    },
    webAdvantagesSince:{
        display:'table-cell',
        width:'50%'
    },
    priceStyle:{
        display:'table-cell',
        width:'50%',
        fontSize:'16px',
        fontWeight:'bold',
        textAlign:'right'
    },
    webAdvantagesPriceText:{
        display:'table-cell',
        textAlign:'right',
        width:'50%'
    },
    webAdvantagesRoomList:{
        display:'block',
        padding:'8px 10px 5px 0',
        fontSize: '14px',
        borderBottom:'1px dotted #ddd',
    },
    dropDownEnter: {
        transition: 'max-height 0ms ease-out',
        maxHeight: '0'
    },
    dropDownEnterActive: {
        maxHeight: '300px',
        transition: 'max-height 300ms ease-out',
        overflow: 'hidden'
    },
    dropDownLeave: {
        maxHeight: '300px',
        transition: 'max-height 0 ease-out',
        overflow: 'hidden'
    },
    dropDownLeaveActive: {
        maxHeight: 0,
        transition: 'max-height  300ms ease-out'
    },
    buttonEnter:{
        opacity: 0,
        transition: 'opacity 0ms ease-out',
        position:'absolute',
        bottom:'0',
        right:'0',
        left:'0',
        zIndex: 1
    },
    buttonEnterActive:{
        opacity: 1,
        transition: 'opacity 0 ease-out',
        transitionDelay: '.1s'
    },
    buttonLeave:{
        position:'absolute',
        bottom:'0',
        right:'0',
        left:'0',
        opacity: 0,
        transition: 'opacity 300ms ease-out'
    },
    buttonLeaveActive:{}
}